import { RequireOnly } from '@pelicargo/types';
import { Quote } from '@prisma/client';

/** Whether the provider has been told a spot rate was accepted. Stamped when the booking email goes out. */
export const isProviderBookingConfirmed = (
  quote?: RequireOnly<Quote, 'provider_booking_confirmed_at'> | null,
): boolean => !!quote?.provider_booking_confirmed_at;
